export const selectSyiAttributes = (state) => state.views.syi.attributes;

export const selectCategoryAttributes = (state) =>
    selectSyiAttributes(state).categoryAttributes;

export const selectCategorySuggestedAttributes = (state) =>
    selectSyiAttributes(state).selectableCategorySuggestedAttributes;

export const selectImageToColorSuggestedAttributes = (state) =>
    selectSyiAttributes(state).imageToColorSuggestedAttributes;
